import React, { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import AuthLayout from "../layouts/AuthLayout";
import AdminLayout from "../layouts/AdminLayout";
import routes from "./routes";
import AdminRoute from "./AdminRoute";
import { getUser } from "../../redux/auth/authSlice";

function ProtectedRoutes() {
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getUser());
  }, [dispatch]);

  // Separate routes into admin and non-admin routes
  const adminRoutes = routes.filter((route) => route.isAdmin);
  const regularRoutes = routes.filter((route) => !route.isAdmin);

  // Restrict admins from accessing regular routes
  const restrictAccessToRegularRoutes = ({ component: Component, path }) => {
    if (isAuthenticated && user?.isAdmin) {
      return <Navigate to="/admin/users" />;
    }
    return (
      <AuthLayout>
        <Component />
      </AuthLayout>
    );
  };

  return (
    <Routes>
      {/* Render regular routes */}
      {regularRoutes.map(({ component: Component, path, exact }, index) => (
        <Route
          key={index}
          path={path}
          exact={exact}
          element={restrictAccessToRegularRoutes({
            component: Component,
            path,
          })}
        />
      ))}

      {/* Render admin routes */}
      {adminRoutes.map(({ component: Component, path, exact }, index) => (
        <Route
          key={index}
          path={path}
          exact={exact}
          element={
            <AdminLayout>
              <AdminRoute>
                <Component />
              </AdminRoute>
            </AdminLayout>
          }
        />
      ))}
    </Routes>
  );
}

export default ProtectedRoutes;
